/* eslint-disable */
const de = require('./authx-login-de-DE.json')
const en = require('./authx-login-en.json')
const es = require('./authx-login-es-ES.json')
const fr = require('./authx-login-fr-FR.json')
const id = require('./authx-login-id-ID.json')
const it = require('./authx-login-it-IT.json')
const pt = require('./authx-login-pt-PT.json')
const th = require('./authx-login-th-TH.json')
export const prefix = 'authx-login'
export default {
  de,
  en,
  es,
  fr,
  id,
  it,
  pt,
  th,
}
